import Http from "@/api/http";

export default {
  /* 老师管理 */
  /* 老师 列表 */
  teacherBasicPage: params => {
    return Http.POST("/teacherBasic/findByPage", params);
  },
  /* 老师 新增/修改 */
  teacherBasicSave: params => {
    return Http.POST("/teacherBasic/save", params);
  },
  /* 老师 导入上传 */
  teacherBasicImportFile: params => {
    return Http.POST("/teacherBasic/importFile", params);
  },
  // 删除
  teacherBasicDelete: params => {
    return Http.GET("/teacherBasic/delete", params);
  },
};
